import { useState, useEffect } from 'react'

const useMobile = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [screenSize, setScreenSize] = useState('desktop')

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth
      const height = window.innerHeight
      
      setIsMobile(width < 768)
      setIsTablet(width >= 768 && width < 1024)
      
      if (width < 480) {
        setScreenSize('mobile-small')
      } else if (width < 768) {
        setScreenSize('mobile')
      } else if (width < 1024) {
        setScreenSize('tablet')
      } else {
        setScreenSize('desktop')
      }
    }

    checkDevice()
    window.addEventListener('resize', checkDevice)
    return () => window.removeEventListener('resize', checkDevice)
  }, [])

  return { 
    isMobile, 
    isTablet, 
    screenSize,
    isMobileSmall: screenSize === 'mobile-small',
    isMobileOrTablet: isMobile || isTablet
  }
}

export default useMobile
